import { render, staticRenderFns } from "./UserFieldEditForm.vue?vue&type=template&id=0af4e0c3&scoped=true&"
import script from "./UserFieldEditForm.vue?vue&type=script&lang=js&"
export * from "./UserFieldEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldEditForm.vue?vue&type=style&index=0&id=0af4e0c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4e0c3",
  null
  
)

export default component.exports